module.exports = __webpack_public_path__ + "img/IMG_9458_59_60_L_Foamcore_MockedUp.d32484c8.jpg";